<template>
    <div>
        <introduction-title en-title="COMPANY INTRODUCTION" ch-title="公司简介" style="margin-top: 20px"></introduction-title>
        <div class="introduction">
            <div class="imgWap">
                <img src="../../../assets/image/introduction-img.png">
            </div>
            <div class="textWap">
                <div class="text">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;重庆市斯普瑞科技有限责任公司是一家专业从事新能源、新材料、医药农药中间体等化学品工艺技术开发和市场运营的新型科技企业。公司聚焦于技术和市场，通过提供先进生产工艺技术，结合优势生产资源，为客户提供高性价比的化学品服务。
                    <br />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;在锂电池添加剂领域，公司已开发和运营的产品有碳酸亚乙烯酯（VC）、碳酸乙烯亚乙酯（VEC）、亚硫酸乙烯酯（ES）、硫酸乙烯酯（DTD）、乙二醇（双）丙腈醚（DENE）、乙氧基五氟环三磷腈（NPCF）；正在推进开发和运营的产品有双氟磺酰亚胺锂（LiFSI）、二氟磷酸锂、氟磺酸锂、负极添加剂和导电剂碳纳米管等产品。
                    <br />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;在医药农药中间体领域，公司已开发和运营的产品有(S)-4-氯-3-羟基丁腈（A3）、（(R)-4-氯-3-羟基丁腈、(R)-4-氰基-3-羟基丁酸乙酯、2-羟基戊腈、环己酮氰醇；正在推进开发和运营的产品有环戊酮氰醇、17β-氰基-17α-羟基雄甾-4-烯-3-酮、3,6-二羟基邻苯二甲腈、米氏酸等产品。
                    <br />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;公司有专业的研发、工程和运营团队；在重庆巴南区国际生物城建有产业化研发中心；生产合作伙伴分布于辽宁营口、辽宁锦州、山东潍坊、河南洛阳、甘肃金昌、福建邵武、福建福州、四川广安、四川眉山、重庆涪陵、贵州黔东南等地。可以为我们的客户提供氰化、氯化、加氢、氯甲基化、氰乙基化等反应相关产品服务。</div>
            </div>
            <div style="clear: both"></div>
        </div>
        <introduction-title en-title="CORPORATE CULTURE" ch-title="公司文化" style="margin-top: 20px"></introduction-title>
        <div class="culture">
            <div class="li">
                <span>愿景</span>
                <span>国际一流的化学品服务提供商</span>
            </div>
            <div class="li">
                <span>使命</span>
                <span>开发环境友好化学品和环境友好技术，提高生活质量的同时保护好我们的生存环境</span>
            </div>
            <div class="li">
                <span>价值观</span>
                <span>坦诚、开放、共赢</span>
            </div>
        </div>
    </div>
</template>

<script>
    import IntroductionTitle from "../../../components/wap/introductionTitle";
    export default {
        name: "wapCompanyIntroduction",
        components: {IntroductionTitle}
    }
</script>

<style scoped>
    .introduction{
        margin-top: 20px;
        margin-bottom: 20px;
    }
    .introduction .imgWap{
        width: 355px;
        /*height: 320px;*/
        margin:0 auto 0;
    }
    .introduction .textWap{
        width:355px;
        margin: 0 auto 0;
        height: 100%;
    }
    .introduction .textWap .text{
        width:355px;
        height:100%;
        font-size: 14px;
        font-family: MicrosoftYaHei;
        color: #363A44;
        line-height: 28px;
        text-align: justify;
    }
    .introduction .imgWap img{
        width: 100%;
        height: 100%;
    }
    .culture{
        cursor: text;
        margin-top: 20px;
        display: flex;
        justify-content: center;
        flex-wrap: wrap;
        margin-bottom: 40px;
    }
    .culture .li{
        width: 355px;
        height: 170px;
        background: #FFFFFF;
        border-radius: 10px;
        border: 1px solid #E6E8EB;
        margin-bottom:10px;
    }
    .culture .li:hover{
        /* cursor: pointer; */

    }
    .culture .li span{
        display:block ;
        text-align: center;
    }
    .culture .li span:nth-child(1){
        height: 21px;
        font-size: 16px;
        font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
        font-weight: bold;
        color: #0067AC;
        margin-top: 40px;
        text-align: center;
    }
    .culture .li span:nth-child(2){
        width: 280px;
        height: 48px;
        font-size: 14px;
        font-family: MicrosoftYaHei;
        color: #363A44;
        margin-top: 20px;
        margin-left: 38px;
    }
</style>
